import React from "react"
import Footer from "../containers/Footer"
import Navbar from "../containers/Navbar"
import "./layout.css"
import SEO from "./seo"

const Layout = ({ children }) => {
  return (
    <>
      <SEO title="Home" />
      <Navbar />
      {children}
      <Footer />
    </>
  )
}

export default Layout
